import { forwardRef, ReactNode } from 'react';
import { Option } from '../../../../types/Form';
import InputError from '../Error';
import styles from './Select.module.css';

export interface SelectProps
  extends React.DetailedHTMLProps<
    React.SelectHTMLAttributes<HTMLSelectElement>,
    HTMLSelectElement
  > {
  label?: string | number;
  error?: string;
  children?: ReactNode;
  customClassName?: string;
  options?: Option[];
}
const Select = forwardRef<HTMLSelectElement, SelectProps>(
  (
    { customClassName, label, error, children, id, disabled, options, ...rest },
    ref
  ) => (
    <div className={`${customClassName}`}>
      <label
        className={`leading-7 block text-sm text-neutralColor-medium mr-4 w-full`}
        htmlFor={id}
      >
        {label}
      </label>
      <select
        ref={ref}
        className={`
        ${disabled && styles['form-select-disabled']}
        ${error && styles['form-select-error']}
        ${styles['form-select-normal']}`}
        id={id}
        disabled={disabled}
        {...rest}
      >
        {options?.length ? (
          <>
            <option value=''>Select</option>
            {options.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </>
        ) : (
          children
        )}
      </select>
      {error && <InputError>{error}</InputError>}
    </div>
  )
);

export default Select;
